export const userKey = "user";
export const folderKey = "folder";
export const folderImageKey = "images";
export const foldersListKey = "poc_folders"; // For storing list of all folders in POC mode